export const ExamTypes = {
	BASIC: "basic",
	COURSE: "course",
	SIMULATION: "simulation",
	LEARNING: "learning",
};

export const ExamStatus = {
	ACTIVE: "unfinished",
	FINISHED: "finished",
};

export const ExamState = {
	PENDING: "pending",
	PAUSED: "paused",
	EXPIRED: "expired",
};

export const AnswerType = {
	CORRECT: "correct",
	WARNING: "warning",
	WRONG: "wrong",
	HIDDEN: "hidden",
};

export const ExamResultType = {
	PASSED: "passed",
	FAILED: "failed",
	EXPIRED: "expired",
};

export const PromptType = {
	ANSWER_DETAILS: "answerDetails",
	ANSWERS_DETAILS: "answersDetails",
	QUESTION_TUTOR: "questionTutor",
	CONVERSATION: "conversation",
};

export const ItemTypes = {
	QUESTION: "question",
	CONVERSATION: "conversation",
};

export const ModalMaxWidth = {
	xs: "xs",
	sm: "sm",
	md: "md",
	lg: "lg",
	xl: "xl",
};
